import React, { useState, useEffect, useMemo } from 'react';

// LoadPanel
import { LoadPanel } from 'devextreme-react/load-panel';

// Grid
import DataGrid, {
  Column, FilterRow, HeaderFilter, FilterPanel, FilterBuilderPopup,
  GroupPanel, Grouping, SearchPanel,
  Scrolling, Pager, Paging, StateStoring, ColumnChooser, Export,
  ColumnChooserSearch, ColumnChooserSelection
} from 'devextreme-react/data-grid';

//CheckBox
import CheckBox from 'devextreme-react/check-box';

import { get } from 'aws-amplify/api';

import { fetchAuthSession } from 'aws-amplify/auth';

// Ruteador
import { Link } from "react-router-dom";

// Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt } from "@fortawesome/pro-solid-svg-icons";
import { faList } from "@fortawesome/pro-duotone-svg-icons";

import { callProcesa } from '../api/callProcesa';

import './Users.css';

import '../ListStyle.css';

import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter'

export default function UsersGrid(props) {
  const [userRecords, setUserRecords] = useState([]);

  const [autoExpandAll, setAutoExpandAll] = useState(true);

  const [visibleLoadPanel, setVisibleLoadPanel] = useState(false);

  // eslint-disable-next-line no-unused-vars
  const [ok, setOk] = useState(false);

  function getOrderDay(rowData) {
    return (new Date(rowData.OrderDate)).getDay();
  };

  const filterBuilder = useMemo(() => {
    return {
      customOperations: [{
        name: 'weekends',
        caption: 'Weekends',
        dataTypes: ['date'],
        icon: 'check',
        hasValue: false,
        calculateFilterExpression: () => [[getOrderDay, '=', 0], 'or', [getOrderDay, '=', 6]],
      }],
      allowHierarchicalFields: true,
    };
  }, []);

  const filterBuilderPopupPosition = useMemo(() => {
    return {
      of: window,
      at: 'top',
      my: 'top',
      offset: { y: 10 },
    };
  }, []);

  const allowedPageSizes = useMemo(() => {
    return [5, 10, 15, 20, 'all'];
  }, []);

  const getUsersList = React.useCallback(async () => {
    // Obtenemos los usuarios de Cognito
    let apiNameCognito = 'AdminQueries';
    let pathCognito = '/listUsers';

    let optionsCognito = {
      headers: {
        'Content-Type': 'application/json',
      }
    }

    var response = await get({
      apiName: apiNameCognito,
      path: pathCognito,
      options: optionsCognito
    }).response;

    const { NextToken, ...restCognito } = await response.body.json();

    var users = [];

    // Obtenemos los atributos de los usuarios desde Netsuite
    var usersGet = await callProcesa('/procesausuario', {
      action: 'list'
    });

    for (var singleUserIndex in restCognito.Users) {
      var singleUser = restCognito.Users[singleUserIndex];

      var addUser = {
        Username: singleUser.Username,
        Enabled: singleUser.Enabled,
        isAdmin: singleUser.isAdmin
      };

      if (singleUser.Enabled)
        addUser.Enabled = 'Activo'
      else
        addUser.Enabled = 'Inactivo'

      if (singleUser.isAdmin)
        addUser.isAdmin = 'Admin'
      else
        addUser.isAdmin = ''

      // Agregamos el email
      for (var attributeIndex in singleUser.Attributes) {
        var singleAttribute = singleUser.Attributes[attributeIndex];

        if (singleAttribute.Name === 'email')
          addUser.Email = singleAttribute.Value;
      }

      // Agregamos el resto de los atributos
      for (var usersGetIndex in usersGet.data) {
        var singleUserGet = usersGet.data[usersGetIndex];

        if (singleUserGet.userName === singleUser.Username) {
          addUser.internalid = singleUserGet.internalid;
          addUser.cluster = singleUserGet.cluster;
          addUser.clusterLevel = singleUserGet.clusterLevel;
          addUser.location = singleUserGet.location;
          addUser.locationLevel = singleUserGet.locationLevel;
          addUser.clusterType = singleUserGet.clusterType;
          addUser.clusterType = singleUserGet.clusterTypeLevel;
          addUser.productCluster = singleUserGet.productCluster;
          addUser.productClusterLevel = singleUserGet.productClusterLevel;
          addUser.custrecord_al_portal_employee = singleUserGet.custrecord_al_portal_employee;

        }
      }
      users.push(addUser);
    }

    setUserRecords(users);
  }, []);

  const onAutoExpandAllChanged = React.useCallback(() => {
    setAutoExpandAll(!autoExpandAll)
  }, [autoExpandAll]);

  useEffect(() => {
    async function initialize() {
      setVisibleLoadPanel(true);

      const session = await fetchAuthSession();

      var groups = session.tokens.accessToken.payload["cognito:groups"];

      var okAdmin = false;

      for (var groupIndex in groups) {
        var singleGroup = groups[groupIndex];

        if (singleGroup === 'Admin') {
          setOk(true);
          okAdmin = true;
        }
      }

      if (okAdmin === true) {
        await getUsersList();
      }

      setVisibleLoadPanel(false);
    }

    initialize();

    // eslint-disable-next-line
  }, []);

  const editUser = React.useCallback((data) => {
    return (
      <Link to={`/Users/${data.data.Username}`}>
        <button class="bg-blue-500 hover:bg-blue-700 text-white  py-1 px-3 rounded"><FontAwesomeIcon icon={faPencilAlt} /> Editar</button>
      </Link>
    )
  }, [])

  const userEnabled = React.useCallback((data) => {
    return (
      <span className={data.data.Enabled === "Activo" ? "px-2 py-1 font-semibold leading-tight text-green-700 bg-green-100 rounded-sm" : "px-2 py-1 font-semibold leading-tight text-red-700 bg-red-100 rounded-sm"}> {data.data.Enabled} </span>
    )
  }, []);

  const userAdmin = React.useCallback((data) => {
    return (
      <span className={data.data.isAdmin === "Admin" ? "px-2 py-1 font-semibold leading-tight text-pink-700 bg-pink-100 rounded-sm}" : ""} > {data.data.isAdmin === "Admin" ? "Si" : ""}</span>
    )
  }, []);

  function onExporting(e) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Datos');

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Datos.xlsx');
      });
    });
    e.cancel = true;
  };

  return (
    <div>
      <div class="bg-gray-200 m-2">
        <h1 class="font-sans inline-block text-xl font-bold text-gray-700 leading-8 align-top mb-1"><FontAwesomeIcon icon={faList} size="lg" /> Usuarios</h1>
      </div>

      <LoadPanel
        shadingColor="rgba(0,0,0,0.4)"
        visible={visibleLoadPanel}
        showIndicator={true}
        message="Por favor espere..."
        shading={true}
        showPane={true}
        hideOnOutsideClick={false}
      />

      <div class="bg-gray-200 m-2">
        <div class="bg-white p-3 shadow-xl">
          <div className="options mb-2">
            <div className="option">
              <CheckBox text="Expandir todos los grupos"
                value={autoExpandAll}
                onValueChanged={onAutoExpandAllChanged}>
              </CheckBox>
            </div>
          </div>
          <DataGrid
            id="gridContainer"
            columnsAutoWidth={true}
            filterBuilder={filterBuilder}
            dataSource={userRecords}
            allowColumnReordering={true}
            allowColumnResizing={true}
            columnResizingMode="widget"
            showBorders={true}
            rowAlternationEnabled={true}
            showRowLines={true}
            showColumnLines={true}
            onExporting={onExporting}
          >
            <Scrolling rowRenderingMode='virtual'></Scrolling>
            <Paging defaultPageSize={10} />
            <Pager
              visible={true}
              allowedPageSizes={allowedPageSizes}
              displayMode='compact'
              showPageSizeSelector={true}
              showInfo={true}
              showNavigationButtons={true} />
            <FilterRow visible={true} />
            <FilterPanel visible={true} />
            <FilterBuilderPopup position={filterBuilderPopupPosition} />

            <HeaderFilter visible={true} />

            <GroupPanel visible={true} />
            <SearchPanel visible={true} />
            <ColumnChooser
              enabled={true}
              mode='select'
            >
              <ColumnChooserSearch
                enabled={true}
              />

              <ColumnChooserSelection
                allowSelectAll={true}
                selectByClick={true}
                recursive={true}
              />
            </ColumnChooser>
            <Grouping autoExpandAll={autoExpandAll} />
            <Export enabled={true} />
            <StateStoring enabled={true} type="localStorage" storageKey="gridContainerListUsers" />

            <Column caption="" alignment="center" width={100} cellRender={editUser} />

            <Column caption="Usuario" dataField="Username" dataType="string" width={150} />
            <Column caption="Correo Electronico" dataField="Email" dataType="string" width={200} />

            <Column caption="Estatus" alignment="center" width={120} cellRender={userEnabled} />

            <Column caption="Administrador" alignment="center" width={200} cellRender={userAdmin} />
            <Column caption="Clusters" dataField="cluster" dataType="boolean" width={200} visible={false} />
            <Column caption="Nivel Clusters" dataField="clusterLevel" dataType="string" width={200} visible={false} />
            <Column caption="Location" dataField="location" dataType="boolean" width={200} visible={false} />
            <Column caption="Nivel Location" dataField="locationLevel" dataType="string" width={200} visible={false} />
            <Column caption="Product-Clusters" dataField="productCluster" dataType="boolean" width={200} visible={false} />
            <Column caption="Nivel Product-Clusters" dataField="productClusterLevel" dataType="string" width={200} visible={false} />
            <Column caption="Cluster Type" dataField="clusterType" dataType="boolean" width={200} visible={false} />
            <Column caption="Nivel Cluster Type" dataField="clusterTypeLevel" dataType="string" width={200} visible={false} />
            <Column caption="Empleado Netsuite" dataField="custrecord_al_portal_employee" dataType="string" width={250} visible={false} />

            <Column caption="internalid" dataField="internalid" dataType="number" width={200} visible={false} />

          </DataGrid>
        </div>
      </div>
    </div>
  );
}
